import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MarkdownService } from 'ngx-markdown';

@Component({
  selector: 'app-tos',
  templateUrl: './tos.component.html',
  styleUrls: ['./tos.component.scss']
})
export class TosComponent implements OnInit {

  md: string = '';
  constructor(
    private http: HttpClient,
    private mdService: MarkdownService,
  ) { }

  ngOnInit(): void {
    this.loadToS();
  }

  async loadToS() {
    this.http.get(`/assets/tos/tos.md`,
      { responseType: 'text' }).subscribe({
        next: (res) => {
          console.log(this.mdService.compile(res));
          this.md =this.mdService.compile(res);
        },
        error: (err) => {
          console.error(err);
        }
      });
  }
}
